/* Portado VERBATIM desde boston_ia/index.html — logica original respetada.
   Fuente: C:\\xampp\\htdocs\\boston_ia\\index.html */
import { state, emit, uuidV4, Storage } from './store'
import JSZip from 'jszip'

/* Etiqueta legible para un postCommand: puede ser STRING (comando GDS) u OBJETO
   directiva ({deleteRemarks}, {if}, {read}, {compute}, {loop}). Renderear el objeto
   directo en JSX rompe React ("Objects are not valid as a React child"). */
/* Espejo de los guards del runtime: ¿este campo NO emite ningun comando?
   (labels/botones = visuales; skip=true sin mascara ni remark = dato interno) */
export function csFieldNoWrite(f) {
  if (!f) return false
  if (f.typedata === 'label' || f.typedata === 'button') return true
  return f.skip === true && !String(f.remark_mask || '').trim() && !String(f.remark || '').trim()
}

export function csCmdLabel(c) {
  if (typeof c === 'string') return c
  if (c && typeof c === 'object') {
    if (c.deleteRemarks !== undefined) {
      const d = c.deleteRemarks || {}
      const det = d.match ? 'los que matcheen /' + d.match + '/' : d.range ? 'lineas ' + d.range : d.all === true ? 'TODOS los previos' : '(sin criterio)'
      return '\u{1F5D1} Borrar remarks previos: ' + det + ' (snapshot previo \u00b7 /sabre/deleteremarks)'
    }
    const kind = c.if ? 'if' : c.read ? 'read' : c.compute ? 'compute' : c.loop ? 'loop' : 'directiva'
    try {
      return '\u2699 ' + kind + ' \u00b7 ' + JSON.stringify(c).slice(0, 100)
    } catch (e) {
      return '\u2699 directiva'
    }
  }
  return String(c == null ? '' : c)
}


const __TPL_CACHE__ = { html: null, css: null, app: null, api: null, sst: null };
const DEFAULT_EXTERNAL_CATALOG_THRESHOLD = 20;

const PUBLIC_API_BASE_BY_ENV = {
  stg: 'https://stg.boston.basset.ws',
  stage: 'https://stg.boston.basset.ws',
  prod: 'https://boston.basset.ws',
  production: 'https://boston.basset.ws',
};

function clonePlainJSON(value, fallback = null) {
  try {
    return JSON.parse(JSON.stringify(value == null ? fallback : value));
  } catch (_) {
    return fallback;
  }
}

function normalizeExternalCatalogRoot(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return { version: 1, catalogs: {} };
  const catalogs = value.catalogs && typeof value.catalogs === 'object' && !Array.isArray(value.catalogs)
    ? { ...value.catalogs }
    : { ...value };
  return { ...value, version: value.version || 1, catalogs };
}

function catalogFieldKey(field, formName, index) {
  const raw = [
    field && (field.campoForm || field.tag || field.name || field.id || field.label),
    formName,
    index,
  ].filter((part) => part !== undefined && part !== null && String(part).trim() !== '').join('_');
  return String(raw || 'catalog')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 52) || 'catalog';
}

function catalogHash(options) {
  const text = JSON.stringify(options || []);
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = ((hash << 5) - hash) + text.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(36).slice(0, 6);
}

function normalizeCatalogOptions(options) {
  if (!Array.isArray(options)) return [];
  return options
    .map((option) => {
      if (option && typeof option === 'object') {
        const value = option.value ?? option.id ?? option.codigo ?? option.code ?? option.text ?? option.label ?? '';
        const text = option.text ?? option.label ?? option.descripcion ?? option.nombre ?? option.name ?? option.value ?? '';
        return { ...option, value: String(value ?? ''), text: String(text ?? '') };
      }
      return { value: String(option ?? ''), text: String(option ?? '') };
    })
    .filter((option) => String(option.value || option.text || '').trim() !== '');
}

export function csExternalizeLargeCatalogs(dataJson, options = {}) {
  const threshold = Number(options.threshold || DEFAULT_EXTERNAL_CATALOG_THRESHOLD);
  const data = clonePlainJSON(dataJson, {});
  const root = normalizeExternalCatalogRoot(options.catalogsJson || options.existingCatalogs || null);
  const stats = { refsCreated: 0, optionsMoved: 0, threshold };
  if (!data || typeof data !== 'object') return { data, catalogsJson: root, stats };

  const processField = (field, formName, index) => {
    if (!field || typeof field !== 'object') return;
    const typedata = String(field.typedata || field.type || '').toLowerCase();
    const existingRef = String(field.datasource_ref || field.catalog_ref || '').trim();
    if (existingRef && root.catalogs[existingRef]) {
      field.catalog_ref = existingRef;
      field.datasource_ref = existingRef;
      field.datasource_count = root.catalogs[existingRef]?.count || root.catalogs[existingRef]?.options?.length || field.datasource_count || 0;
      field.datasource = [];
      return;
    }
    if (field.catalog_ref || field.datasource_ref) return;
    const datasource = normalizeCatalogOptions(field.datasource);
    if (typedata !== 'select' || datasource.length < threshold) return;
    const base = catalogFieldKey(field, formName, index);
    const ref = `cat_${base}_${catalogHash(datasource)}`;
    root.catalogs[ref] = {
      id: ref,
      label: field.label || field.tag || field.campoForm || base,
      field: field.campoForm || field.tag || field.id || '',
      source: 'data_json_externalized',
      count: datasource.length,
      options: datasource,
    };
    field.catalog_ref = ref;
    field.datasource_ref = ref;
    field.datasource_count = datasource.length;
    field.datasource = [];
    stats.refsCreated += 1;
    stats.optionsMoved += datasource.length;
  };

  (Array.isArray(data.forms) ? data.forms : []).forEach((form, formIndex) => {
    const formName = form && (form.form || form.id || form.title || `form${formIndex + 1}`);
    (Array.isArray(form?.remarks) ? form.remarks : []).forEach((field, index) => processField(field, formName, index));
    (Array.isArray(form?.fields) ? form.fields : []).forEach((field, index) => processField(field, formName, index));
  });
  (Array.isArray(data.actions) ? data.actions : []).forEach((action, actionIndex) => {
    const formName = action && (action.id || action.label || `action${actionIndex + 1}`);
    (Array.isArray(action?.fields) ? action.fields : []).forEach((field, index) => processField(field, formName, index));
  });

  if (stats.refsCreated > 0) {
    data.catalogs_file = data.catalogs_file || 'catalogs.json';
    data.catalogs_externalized = true;
  }
  return { data, catalogsJson: root, stats };
}

function csNormalizeRuntimeEnv(value) {
  const env = String(value || '').trim().toLowerCase();
  if (env === 'staging') return 'stg';
  if (env === 'prd') return 'prod';
  return env;
}

function csIsLocalApiBaseUrl(value) {
  const raw = String(value || '').trim();
  if (!raw) return false;
  try {
    const parsed = new URL(raw, 'http://localhost');
    return ['localhost', '127.0.0.1', '::1'].includes(parsed.hostname);
  } catch (_) {
    return /^https?:\/\/(localhost|127\.0\.0\.1)(?::|\/|$)/i.test(raw);
  }
}

function csIsCurrentPageLocal() {
  if (typeof window === 'undefined' || !window.location) return false;
  return ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
}

function csPublicApiBaseForEnv(env) {
  return PUBLIC_API_BASE_BY_ENV[csNormalizeRuntimeEnv(env)] || '';
}

function csResolveRuntimePublicApiBaseUrl(value, env, options = {}) {
  const raw = String(value || '').trim().replace(/\/+$/, '');
  const envBase = csPublicApiBaseForEnv(env);
  const allowLocal = options.allowLocal === true;
  if (!raw) return envBase;
  if (csIsLocalApiBaseUrl(raw) && (!allowLocal || !csIsCurrentPageLocal())) return envBase || raw;
  return raw;
}

const LOCAL_RUNTIME_TEMPLATES = {
  'index.html': `<!doctype html>
<html lang="es">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width,initial-scale=1">
  <title>Boston Custom Script</title>
  <link rel="stylesheet" href="styles.css">
</head>
<body>
  <main class="boston-script-shell">
    <header class="boston-script-header">
      <h1 id="headerTitle">Boston Custom Script</h1>
      <div class="boston-script-meta">
        <span id="scriptNameBadge">custom_script</span>
        <span id="uuidBadge">no-uuid</span>
      </div>
    </header>
    <section id="app" class="boston-script-app"></section>
  </main>
  <script src="api.js"></script>
  <script src="app.js"></script>
</body>
</html>`,
  'styles.css': `:root{font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:#172033;background:#f5f7fb}*{box-sizing:border-box}body{margin:0}.boston-script-shell{max-width:1040px;margin:0 auto;padding:24px}.boston-script-header{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;margin-bottom:18px}.boston-script-header h1{font-size:24px;margin:0}.boston-script-meta{display:flex;gap:8px;flex-wrap:wrap}.boston-script-meta span,.pill{border:1px solid #d7deea;border-radius:999px;padding:4px 10px;background:#fff;font-size:12px}.card{background:#fff;border:1px solid #d7deea;border-radius:8px;padding:16px;margin-bottom:14px;box-shadow:0 8px 22px rgba(23,32,51,.06)}label{display:block;font-size:12px;font-weight:700;margin:10px 0 4px}input,select,textarea{width:100%;border:1px solid #cbd5e1;border-radius:6px;padding:9px 10px;font:inherit}textarea{min-height:74px}button{border:0;border-radius:6px;padding:9px 14px;font-weight:700;background:#166534;color:#fff;cursor:pointer}button.secondary{background:#475569}.actions{display:flex;gap:8px;flex-wrap:wrap;margin-top:14px}.muted{color:#64748b;font-size:12px}.preview-banner{position:sticky;top:0;z-index:5;background:#f59e0b;color:#fff;text-align:center;font-weight:700;padding:6px 12px}`,
  'api.js': `(function(){
  var ROUTES = {
    'sabre/reservation': { method: 'GET', path: '/sabre/reservation' },
    'sabre/remarks': { method: 'GET', path: '/sabre/remarks' },
    'sabre/addremarks': { method: 'POST', path: '/sabre/addremarks' },
    'sabre/modifyremarks': { method: 'POST', path: '/sabre/modifyremarks' },
    'sabre/deleteremarks': { method: 'POST', path: '/sabre/deleteremarks' },
    'sabre/executeCommand': { method: 'GET', path: '/sabre/executeCommand' },
    'customScripts/session': { method: 'GET', path: '/customScripts/session' },
    'customScripts/config': { method: 'GET', path: '/customScripts/config' },
    'customScripts/getCustomScriptConfig': { method: 'GET', path: '/customScripts/getCustomScriptConfig' },
    'catalogues': { method: 'GET', path: '/catalogues/getCataloguesPCC' },
    'catalogues/name': { method: 'GET', path: '/catalogues/getCataloguesPCCAndName' },
    'agency/active': { method: 'GET', path: '/agency/active' }
  };
  var params = new URLSearchParams(window.location.search);
  window.TOKEN = params.get('token') || window.__PREVIEW_TOKEN__ || '';
  window.ENV = String(params.get('env') || window.__PREVIEW_ENV__ || config().env || 'stg').toLowerCase();
  var BLOCKED = [
    '/admin/ai',
    '.php',
    'scripts_ia',
    'x-bia-token',
    'save_script',
    'ai_generate',
    'knowledge_save',
    'api-bostonflows',
    '/boston/admin/ai'
  ];
  function config(){
    return (window.__BOSTON_CONFIG__ && window.__BOSTON_CONFIG__.config) || {};
  }
  function cleanPath(value){
    var out = String(value || '').trim();
    while (out.charAt(0) === '/') out = out.slice(1);
    while (out.indexOf('../') !== -1) out = out.split('../').join('');
    return out;
  }
  function blocked(value){
    var lower = String(value || '').toLowerCase();
    for (var i = 0; i < BLOCKED.length; i += 1) {
      if (lower.indexOf(BLOCKED[i]) !== -1) return true;
    }
    return false;
  }
  function stripTrailingSlash(value){
    var out = String(value || '').trim();
    while (out.charAt(out.length - 1) === '/') out = out.slice(0, -1);
    return out;
  }
  function baseUrl(cfg, env){
    var explicit = cfg.publicApiBaseUrl || cfg.apiBaseUrl || '';
    if (explicit) return stripTrailingSlash(explicit);
    return '';
  }
  function appendQuery(url, query){
    var parts = [];
    Object.keys(query || {}).forEach(function(key){
      var value = query[key];
      if (value !== undefined && value !== null && String(value) !== '') {
        parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(String(value)));
      }
    });
    return parts.length ? url + (url.indexOf('?') === -1 ? '?' : '&') + parts.join('&') : url;
  }
  function payload(body){
    return body && typeof body === 'object' ? body : {};
  }
  function splitEndpoint(endpoint){
    var value = cleanPath(endpoint);
    var idx = value.indexOf('?');
    return { key: idx >= 0 ? value.slice(0, idx) : value, search: idx >= 0 ? value.slice(idx + 1) : '' };
  }
  function queryFor(endpoint, body, cfg, search){
    var data = payload(body);
    var query = {};
    var urlParams = new URLSearchParams(search || '');
    urlParams.forEach(function(value, key){ query[key] = value; });
    if (endpoint === 'sabre/executeCommand') query.command = query.command || data.command || (typeof body === 'string' ? body : '');
    if (endpoint === 'customScripts/config') {
      query.uuid = query.uuid || data.uuid || cfg.uuid || '';
      query.pcc = query.pcc || data.pcc || cfg.pcc || '';
      query.type_assign = query.type_assign || data.type_assign || data.typeAssign || cfg.type_assign || cfg.typeAssign || '';
    }
    if (endpoint === 'customScripts/getCustomScriptConfig') query.uuid = query.uuid || data.uuid || cfg.uuid || '';
    if (endpoint === 'catalogues') query.ppcc = query.ppcc || data.ppcc || data.parentPcc || cfg.ppcc || cfg.parentPcc || cfg.parent_pcc || '';
    if (endpoint === 'catalogues/name') return {
      ppcc: query.ppcc || data.ppcc || data.parentPcc || cfg.ppcc || cfg.parentPcc || cfg.parent_pcc || '',
      name: query.name || data.name || data.name_catalog || ''
    };
    return query;
  }
  window.callAPI = async function(endpoint, method, body){
    if (window.__BOSTON_SIMULATE_API__) return { preview:true, simulated:true, endpoint:endpoint, method:method || 'GET', body:body || null };
    var cfg = config();
    var token = params.get('token') || window.__PREVIEW_TOKEN__ || '';
    var env = params.get('env') || window.__PREVIEW_ENV__ || cfg.env || 'stg';
    var rawMethod = method || 'GET';
    var requestedMethod = String(rawMethod).toUpperCase();
    if (cfg.enableRuntimeApi !== true) {
      return { pending:true, endpoint:endpoint, method:rawMethod, env:env, token:token ? 'present' : 'missing' };
    }
    var parsed = splitEndpoint(endpoint);
    var key = parsed.key;
    if (blocked(endpoint) || blocked(key)) return { ok:false, blocked:true, error:'Endpoint bloqueado para runtime', endpoint:endpoint };
    var route = ROUTES[key];
    if (!route) return { ok:false, blocked:true, error:'Endpoint no permitido para runtime', endpoint:endpoint };
    if (requestedMethod !== route.method) return { ok:false, error:'Metodo no permitido para ' + key, expected:route.method, received:requestedMethod };
    var resolvedBaseUrl = baseUrl(cfg, env);
    if (!resolvedBaseUrl) return { ok:false, error:'Falta publicApiBaseUrl/apiBaseUrl en config_app.json', endpoint:key, env:env };
    var url = appendQuery(resolvedBaseUrl + route.path, queryFor(key, body, cfg, parsed.search));
    var headers = { 'Accept': 'application/json, text/plain, */*', 'Content-Type': 'application/json' };
    if (token) headers.token = token;
    if (cfg.apiKey) headers['x-api-key'] = cfg.apiKey;
    var init = { method: route.method, headers: headers };
    if (route.method !== 'GET' && body !== undefined && body !== null) init.body = typeof body === 'string' ? body : JSON.stringify(body);
    var response = await fetch(url, init);
    var text = await response.text();
    var data = text;
    try { data = text ? JSON.parse(text) : null; } catch (_) {}
    if (!response.ok) {
      var message = (data && (data.message || data.error)) || text || ('HTTP ' + response.status);
      throw new Error(message);
    }
    return data;
  };
  window.readReservation = function(){ return window.callAPI('sabre/reservation', 'GET'); };
  window.readRemarks = function(){ return window.callAPI('sabre/remarks', 'GET'); };
  window.addRemarks = function(remarksArr){ return window.callAPI('sabre/addremarks', 'POST', { Remarks: remarksArr }); };
  window.modifyRemarks = function(remarksArr){ return window.callAPI('sabre/modifyremarks', 'POST', { Remarks: remarksArr }); };
  window.deleteRemarks = function(remarksArr){ return window.callAPI('sabre/deleteremarks', 'POST', { Remarks: remarksArr }); };
  window.executeCommand = function(cmd){ return window.callAPI('sabre/executeCommand', 'GET', { command: cmd }); };
  window.getCataloguesPCC = function(pcc, uuid){ return window.callAPI('catalogues', 'GET', { ppcc: pcc, uuid: uuid }); };
  window.saveReservation = function(){ return window.executeCommand('ER'); };
  window.readDK = async function(){ var rsp = await window.executeCommand('*PDK'); var txt = JSON.stringify(rsp); var m = txt.match(/\\b\\d{6}\\b/); return m ? m[0] : null; };
})();`,
  'app.js': `(function(){
  function el(tag, attrs){ var node=document.createElement(tag); Object.keys(attrs||{}).forEach(function(k){ if(k==='text') node.textContent=attrs[k]; else if(k==='html') node.innerHTML=attrs[k]; else node.setAttribute(k, attrs[k]); }); return node; }
  function renderField(container, field){
    if(field.typedata === 'label'){ container.appendChild(el('p',{text:field.label || field.title || ''})); return; }
    if(field.typedata === 'button'){ container.appendChild(el('button',{type:'button',text:field.label || field.title || 'Accion'})); return; }
    container.appendChild(el('label',{text:field.label || field.title || field.tag || 'Campo'}));
    var input;
    if(field.typedata === 'textarea') input=el('textarea',{});
    else if(field.typedata === 'select'){ input=el('select',{}); (field.options||field.datasource||[]).forEach(function(opt){ input.appendChild(el('option',{value:opt.value || opt,text:opt.label || opt.text || opt.name || opt.value || opt})); }); }
    else input=el('input',{type:field.typedata === 'number' ? 'number' : 'text'});
    input.value=field.defaultValue || field.value || ''; input.dataset.tag=field.tag || ''; container.appendChild(input);
  }
  function render(){
    var data = window.__BOSTON_DATA__ || {};
    var root = document.getElementById('app'); if(!root) return;
    root.innerHTML='';
    if(window.__BOSTON_PREVIEW_MODE__) root.appendChild(el('div',{class:'preview-banner',text:'MODO PREVIEW - llamadas remotas simuladas'}));
    (data.forms || []).forEach(function(form){
      var card=el('section',{class:'card'});
      card.appendChild(el('h2',{text:form.title || form.form || 'Formulario'}));
      (form.remarks || []).forEach(function(field){ renderField(card, field); });
      var actions=el('div',{class:'actions'});
      actions.appendChild(el('button',{type:'button',text:'Ejecutar'}));
      actions.appendChild(el('button',{type:'button',class:'secondary',text:'Limpiar'}));
      card.appendChild(actions); root.appendChild(card);
    });
    if(!(data.forms || []).length) root.appendChild(el('section',{class:'card muted',text:'Este script no tiene formularios configurados.'}));
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render); else render();
})();`,
};

async function csLoadRuntimeTemplates(forceRefresh) {
  if (forceRefresh) {
    __TPL_CACHE__.html = null;
    __TPL_CACHE__.css = null;
    __TPL_CACHE__.app = null;
    __TPL_CACHE__.api = null;
    __TPL_CACHE__.sst = null;
  }
  if (!__TPL_CACHE__.html) {
    console.log('[csLoadRuntimeTemplates] loading local runtime templates...');
    const [html, css, app, api, sst] = await Promise.all([
      csFetchTemplate('index.html'),
      csFetchTemplate('styles.css'),
      csFetchTemplate('app.js'),
      csFetchTemplate('api.js'),
      csFetchTemplate('sst-interpreter-v1.js'),
    ]);
    __TPL_CACHE__.html = html;
    __TPL_CACHE__.css = css;
    __TPL_CACHE__.app = app;
    __TPL_CACHE__.api = api;
    __TPL_CACHE__.sst = sst;
    // 🩺 DIAGNOSTICO: verificar que el app.js fetched es la versión correcta
    const dollarApos = (app.match(/\$'/g) || []).length;
    const bodyTags = (app.match(/<\/body>/g) || []).length;
    const verifica = (app.match(/verificá que/g) || []).length;
    console.log('[tpl.app] size:', app.length, 'bytes');
    console.log('[tpl.app] $\' count:', dollarApos, '(expected: 30)');
    console.log('[tpl.app] </body> count IN APP.JS (should be 0!):', bodyTags);
    console.log('[tpl.app] "verificá que" count:', verifica, '(expected: 1)');
    if (bodyTags > 0) {
      console.error('[tpl.app] ⚠⚠⚠ APP.JS DEL SERVIDOR ESTÁ CORRUPTO. Contiene', bodyTags, '</body> tags');
      console.error('[tpl.app] Causa probable: Apache está sirviendo versión cacheada del bug viejo.');
      console.error('[tpl.app] Solución: reiniciar Apache, o forzar reload del .js individual.');
    }
  }
  return __TPL_CACHE__;
}

/**
 * Construye un .html autocontenido: data.json + config_app.json + styles.css
 * + api.js + app.js embebidos. El runtime original no necesita cambios:
 * un fetch-interceptor sirve los JSON embebidos cuando app.js los pide.
 *
 * @param {object} dataJson    El schema del script (lo que va en data.json)
 * @param {object} configJson  Config con uuid (lo que va en config_app.json)
 * @param {object} [opts]      { previewMode:bool, title?:string, name?:string, uuid?:string }
 * @returns {Promise<string>}  HTML completo
 */

async function csFetchTemplate(file) {
  // ⚠ Apache tiene cache rebelde para app.js/api.js/etc — servimos copias -v2 con nombre nuevo.
  // Map: app.js → app-v2.js, api.js → api-v2.js, etc.
  const v2Map = {
    'app.js': 'app-v2.js',
    'api.js': 'api-v2.js',
    'styles.css': 'styles-v2.css',
    'index.html': 'index-v2.html',
  };
  const target = v2Map[file] || file;
  const rawPublicBase = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const publicBase = rawPublicBase === '.' ? '' : rawPublicBase;
  const currentPathBase = (() => {
    if (typeof window === 'undefined' || !window.location) return '';
    const path = String(window.location.pathname || '');
    const markers = ['/bostonscripts/', '/admin/', '/dashboard/'];
    for (const marker of markers) {
      const idx = path.indexOf(marker);
      if (idx > 0) return path.slice(0, idx).replace(/\/$/, '');
    }
    const parts = path.split('/').filter(Boolean);
    return parts.length ? `/${parts[0]}` : '';
  })();
  const runtimeUrl = `${publicBase || ''}/bostonIA/runtime/${target}`;
  const runtimeVersion = 'sst-interpreter-v1-20261022d';
  const withRuntimeVersion = (url) => `${url}${url.includes('?') ? '&' : '?'}v=${runtimeVersion}`;
  const runtimePaths = [
    withRuntimeVersion(runtimeUrl),
    runtimeUrl,
    currentPathBase && withRuntimeVersion(`${currentPathBase}/bostonIA/runtime/${target}`),
    currentPathBase && `${currentPathBase}/bostonIA/runtime/${target}`,
    withRuntimeVersion(`/bostonIA/runtime/${target}`),
    `/bostonIA/runtime/${target}`,
  ].filter((url, index, all) => url && all.indexOf(url) === index);
  const isHtmlResponse = (text) => {
    const trimmed = String(text || '').trim().toLowerCase();
    return trimmed.startsWith('<!doctype html') ||
      trimmed.startsWith('<html') ||
      trimmed.includes('<div id="root"');
  };

  console.log('[csFetchTemplate] runtimeUrl:', runtimeUrl);
  for (const url of runtimePaths) {
    try {
      console.log('[csFetchTemplate] intentando:', url);
      const r = await fetch(url, { cache: 'no-store' });
      if (!r.ok) {
        console.warn('[csFetchTemplate] fallÃ³:', url, r.status);
        continue;
      }
      const text = await r.text();
      if (String(target).endsWith('.js') && isHtmlResponse(text)) {
        console.warn('[csFetchTemplate] fallÃ³:', url, 'respuesta HTML para JS');
        continue;
      }
      if (file === 'app.js' && (!text.includes('date_sabre') || !text.includes('bindRuntimeDatePicker'))) {
        console.warn('[csFetchTemplate] fallo:', url, 'app.js sin soporte date_sabre/date picker');
        continue;
      }
      if (file === 'app.js' && (!text.includes('_rtApplyRemarkTypeOverride') || !text.includes('_rtRemarkTypePrefix'))) {
        console.warn('[csFetchTemplate] fallo:', url, 'app.js sin soporte user config typeremark');
        continue;
      }
      if (file === 'app.js' && !text.includes('_rtHasEffectiveScriptOverlayConfig')) {
        console.warn('[csFetchTemplate] fallo:', url, 'app.js sin validacion de config efectiva');
        continue;
      }
      if (file === 'app.js' && !text.includes("if (normalized === 'Itinerary') return '5.'")) {
        console.warn('[csFetchTemplate] fallo:', url, 'app.js con prefijo Itinerary obsoleto');
        continue;
      }
      if (file === 'app.js' && !text.includes("if (normalized === 'General') return '5'")) {
        console.warn('[csFetchTemplate] fallo:', url, 'app.js con prefijo General obsoleto');
        continue;
      }
      if (file === 'app.js' && (!text.includes('const rawMask = r.remark_mask ||') || !text.includes('const normalizedRemarkType = _rtNormalizeRemarkType(r.typeremark)'))) {
        console.warn('[csFetchTemplate] fallo:', url, 'app.js sin recomposicion final de typeremark');
        continue;
      }
      console.log('[csFetchTemplate] cargado:', url);
      return text;
    } catch (err) {
      console.warn('[csFetchTemplate] fallÃ³:', url, err);
    }
  }
  const template = LOCAL_RUNTIME_TEMPLATES[target] || LOCAL_RUNTIME_TEMPLATES[file];
  if (!template) throw new Error(`Template local no disponible: ${file}`);
  if (file === 'app.js' && (!template.includes('date_sabre') || !template.includes('bindRuntimeDatePicker'))) {
    throw new Error('No se pudo cargar el runtime funcional app-v2.js con soporte date_sabre. Verifica /bostonIA/runtime/app-v2.js antes de publicar.');
  }
  if (file === 'app.js' && (!template.includes('_rtApplyRemarkTypeOverride') || !template.includes('_rtRemarkTypePrefix'))) {
    throw new Error('No se pudo cargar el runtime funcional app-v2.js con soporte de configuracion por usuario para typeremark. Verifica /bostonIA/runtime/app-v2.js antes de publicar.');
  }
  if (file === 'app.js' && !template.includes('_rtHasEffectiveScriptOverlayConfig')) {
    throw new Error('No se pudo cargar el runtime funcional app-v2.js con validacion de config efectiva. Verifica /bostonIA/runtime/app-v2.js antes de publicar.');
  }
  if (file === 'app.js' && !template.includes("if (normalized === 'Itinerary') return '5.'")) {
    throw new Error('No se pudo cargar el runtime funcional app-v2.js con prefijo Itinerary 5. Verifica /bostonIA/runtime/app-v2.js antes de publicar.');
  }
  if (file === 'app.js' && !template.includes("if (normalized === 'General') return '5'")) {
    throw new Error('No se pudo cargar el runtime funcional app-v2.js con prefijo General 5. Verifica /bostonIA/runtime/app-v2.js antes de publicar.');
  }
  if (file === 'app.js' && (!template.includes('const rawMask = r.remark_mask ||') || !template.includes('const normalizedRemarkType = _rtNormalizeRemarkType(r.typeremark)'))) {
    throw new Error('No se pudo cargar el runtime funcional app-v2.js con recomposicion final de typeremark. Verifica /bostonIA/runtime/app-v2.js antes de publicar.');
  }
  return template;
}

function csBuildDataJson() {
  csReindexTags();
  // FIX preservacion: partir del data.json ORIGINAL completo (state.cs.raw) para no perder
  // claves que el builder no edita (onLoad, onlyWrite, enableMetrics, viewCatalogues,
  // messageinitial, scriptType del agente, etc.) y aplicar encima lo editado en el builder.
  const raw = state.cs.raw && typeof state.cs.raw === 'object' ? state.cs.raw : {};
  const out = {
    ...raw,
    title: state.cs.title, scriptType: raw.scriptType || 'custom',
    editCatalogues: state.cs.editCatalogues, reintentos: Number(state.cs.reintentos)||0,
    sendCommands: state.cs.sendCommands, orderExecute: state.cs.orderExecute,
    validateActiveReservation: state.cs.validateActiveReservation,
    forms: state.cs.forms, targetEnv: state.cs.targetEnv,
    // FIX: el runtime (app-v2.js) ejecuta DATA.postCommands || [] — antes se perdian al guardar.
    postCommands: state.cs.postCommands || [],
  };
  delete out._uuid;
  delete out._session;
  return out;
}

function csBuildConfigJson(options = {}) {
  const cfg = state.config || {};
  const cs = state.cs || {};
  const enableRuntimeApi = options.enableRuntimeApi === true || cfg.enableRuntimeApiTest === true || cs.enableRuntimeApi === true;
  const advancedMode = options.advancedMode === true || options.advancedMode === 1 || options.advancedMode === '1';
  const config = { uuid: cs.uuid, useInternalConfig: true, enableRuntimeApi, advancedMode: advancedMode ? 1 : 0 };
  // M3: idioma del script para el runtime (config_app.json.lang)
  try {
    const rawLang = String(cfg.lang || (typeof window !== 'undefined' && window.localStorage.getItem('boston_dashboard_lang')) || 'es').toLowerCase()
    config.lang = rawLang.indexOf('en') === 0 ? 'en' : 'es'
  } catch (_) { config.lang = 'es' }
  const first = (...values) => values.find((value) => value !== undefined && value !== null && String(value).trim() !== '');
  const setIfPresent = (key, value) => {
    const next = first(value);
    if (next !== undefined) config[key] = next;
  };

  const env = first(cfg.env, cfg.environment, cs.targetEnv);
  setIfPresent('publicApiBaseUrl', csResolveRuntimePublicApiBaseUrl(first(cfg.publicApiBaseUrl, cfg.apiBaseUrl, cfg.bostonApi), env));
  setIfPresent('apiBaseUrl', csResolveRuntimePublicApiBaseUrl(cfg.apiBaseUrl, env));
  setIfPresent('apiKey', first(cfg.apiKey, cfg.publicApiKey, cfg.bostonAkey));
  setIfPresent('env', env);
  setIfPresent('pcc', first(cfg.pcc, cfg.PCC));
  setIfPresent('parentPcc', first(cfg.parentPcc, cfg.parent_pcc, cfg.ppcc));
  setIfPresent('user', first(cfg.user, cfg.email));
  setIfPresent('username', first(cfg.username, cfg.userName));
  setIfPresent('type_assign', first(cfg.type_assign, cfg.typeAssign));

  return { config };
}

async function generateScriptFiles(options = {}) {
  const catalogized = csExternalizeLargeCatalogs(csBuildDataJson(), {
    existingCatalogs: state.cs.catalogsJson,
    threshold: options.catalogThreshold || DEFAULT_EXTERNAL_CATALOG_THRESHOLD,
  });
  const dataJson = catalogized.data;
  state.cs.catalogsJson = catalogized.catalogsJson;
  const configJson = csBuildConfigJson({
    enableRuntimeApi: options.enableRuntimeApi !== false,
    advancedMode: options.advancedMode === true,
  });
  const logicJson = state.cs.logicJson || { postCommands: state.cs.postCommands || [] };
  const files = {
    'index.html': await csBuildIndexHtmlFromTemplate(),
    'styles.css': await csFetchTemplate('styles.css'),
    'api.js': await csFetchTemplate('api.js'),
    'app.js': `${await csFetchTemplate('sst-interpreter-v1.js')}\n${await csFetchTemplate('app.js')}`,
    'data.json': JSON.stringify(dataJson, null, 2),
    'config.json': JSON.stringify(configJson, null, 2),
    'config_app.json': JSON.stringify(configJson, null, 4),
    'logic.json': JSON.stringify(logicJson, null, 2),
  };
  if (catalogized.stats.refsCreated > 0 || Object.keys((catalogized.catalogsJson && catalogized.catalogsJson.catalogs) || {}).length > 0) {
    files['catalogs.json'] = JSON.stringify(catalogized.catalogsJson, null, 2);
  }
  if (state.cs.fichaMd) files['FICHA.md'] = state.cs.fichaMd;
  return files;
}

async function csBuildPublishPayload() {
  const files = await generateScriptFiles();
  return {
    script: {
      uuid: state.cs.uuid,
      name: state.cs.name,
      description: state.cs.description || '',
      url: '',
      status: 1,
    },
    files: Object.entries(files).map(([path, content]) => ({
      path,
      content,
      sizeBytes: new Blob([content]).size,
    })),
    updatedUser: 'admin_v2',
  };
}

async function buildScriptBundle() {
  const files = await generateScriptFiles();
  return {
    name: state.cs.name,
    uuid: state.cs.uuid,
    generatedAt: new Date().toISOString(),
    publicationPending: true,
    files,
  };
}

async function previewScriptBundle(opts = {}) {
  return csBuildSingleFile(
    csBuildDataJson(),
    csBuildConfigJson({ advancedMode: opts.advancedMode === true }),
    { previewMode: true, simulateApi: true, ...opts },
  );
}

function downloadScriptFile(filename, content, mime = 'text/plain') {
  const blob = content instanceof Blob ? content : new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

async function downloadScriptBundle(filename = `${state.cs.name}.zip`) {
  downloadScriptFile(filename, await csBuildZip(), 'application/zip');
}

async function csBuildIndexHtmlFromTemplate() {
  let tpl = await csFetchTemplate('index.html');
  const t = state.cs.title || state.cs.name;
  tpl = tpl
    .replace(/<title>[^<]*<\/title>/i, `<title>${t}<\/title>`)
    .replace(/id="headerTitle">[^<]*</, `id="headerTitle">${t}<`)
    .replace(/id="scriptNameBadge">[^<]*</, `id="scriptNameBadge">${state.cs.name}<`)
    .replace(/id="uuidBadge">[^<]*</, `id="uuidBadge">${state.cs.uuid}<`);
  return tpl;
}

async function csSaveToServer() {
  const files = await generateScriptFiles();
  return {
    ok: true,
    publicationPending: true,
    path: 'local://admin_v2/library/' + state.cs.name,
    url: '',
    files: Object.keys(files),
    errors: [],
    filesContent: files,
    message: 'La publicacion remota queda pendiente para una fase posterior.',
  };
}

/**
 * Persiste el state.cs actual en la biblioteca local y genera archivos en memoria.
 * La publicacion remota queda pendiente para una fase posterior.
 * el "Convertir" del .sst, asi cualquier script generado aparece en
 * "Editar existente".
 *
 * @returns { ok: true, item, result } o lanza Error si falla.
 */

async function csPersistAndPublish() {
  // 1. Persistir en biblioteca (localStorage)
  const path = (state.config.baseFolder || 'C:\\').replace(/[\\/]?$/, '\\') + state.cs.name + '\\';
  const item = {
    id: `cs-${state.cs.uuid}`,
    type: 'custom-script',
    name: state.cs.name,
    title: state.cs.title,
    description: state.cs.description || '',
    tags: (state.cs.tags || '').split(',').map(t => t.trim()).filter(Boolean),
    uuid: state.cs.uuid,
    absolutePath: path,
    filename: 'index.html',
    dataJson: csBuildDataJson(),
    configJson: csBuildConfigJson(),
    appJs: state.cs.handlerJs || null, // handler del AGENTE 4 — se re-publica al editar
    fichaMd: state.cs.fichaMd || null, // FICHA.md de documentacion
    targetEnv: state.cs.targetEnv,
    postCommands: state.cs.postCommands || [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    url: '',
    code: JSON.stringify(csBuildDataJson(), null, 2),
  };
  item.singleFileHtml = await csBuildSingleFile(item.dataJson, item.configJson, {
    previewMode: false,
    title: item.title,
    name: item.name,
    uuid: item.uuid,
  });
  item.singleFileBytes = item.singleFileHtml.length;
  const existing = state.library.findIndex(x => x.uuid === state.cs.uuid);
  if (existing >= 0) {
    item.createdAt = state.library[existing].createdAt;
    state.library[existing] = item;
  } else {
    state.library.push(item);
  }
  Storage.saveLibrary(state.library);

  // 2. Generar archivos locales en memoria; no hay publicacion remota en esta fase.
  const result = await csSaveToServer();
  item.absolutePath = result.path;
  item.url = result.url;
  Storage.saveLibrary(state.library);

  return { ok: true, item, result };
}

async function csProposeToKB(item) {
  console.log('[csProposeToKB] creando propuesta de knowledge via /admin/ai');

  try {
    const dj = item && item.dataJson; if (!dj) return;
    const forms = dj.forms || [];
    const totalFields = forms.reduce((a, f) => a + ((f.remarks || []).length), 0);
    const allR = forms.reduce((acc, f) => acc.concat(f.remarks || []), []);
    const hasMenu = allR.some(r => r.typedata === 'button_menu');
    const hasSelect = allR.some(r => r.typedata === 'select');
    const category = hasMenu ? 'menu_workflow' : (hasSelect ? 'lookup_select' : 'remarks');
    const complexity = (totalFields > 8 || forms.length > 1) ? 'advanced' : 'simple';
    const { biaCreateKnowledge } = await import('./biaApi');
    await biaCreateKnowledge({
      uuid: 'auto_' + (item.name || ('s' + Date.now())),
      title: (item.title || item.name || 'Script') + ' (auto)',
      category,
      content: JSON.stringify(dj, null, 2),
      tags: {
        complexity,
        patterns: [],
        agents: ['agent3_gen'],
        priority: 'normal',
        source: 'builder',
      },
      status: 0,
      createdUser: 'admin_v2',
      updatedUser: 'admin_v2',
    });
  } catch (e) { console.warn('[csProposeToKB]', e); }
}

async function csBuildZip() {
  
  const zip = new JSZip();
  const f = zip.folder(state.cs.name);
  const files = await generateScriptFiles();
  Object.entries(files).forEach(([name, content]) => f.file(name, content));
  return await zip.generateAsync({ type:'blob' });
}

async function csBuildSingleFile(dataJson, configJson, opts = {}) {
  const tpl = await csLoadRuntimeTemplates();
  const catalogized = csExternalizeLargeCatalogs(dataJson, {
    existingCatalogs: opts.catalogsJson || opts.catalogs || state.cs.catalogsJson,
    threshold: opts.catalogThreshold || DEFAULT_EXTERNAL_CATALOG_THRESHOLD,
  });
  const runtimeDataJson = catalogized.data;
  const runtimeCatalogsJson = catalogized.catalogsJson;
  if (catalogized.stats.refsCreated > 0) {
    console.log('[catalog externalize] single-file', catalogized.stats);
  }
  const title = opts.title || runtimeDataJson?.title || state.cs.title || 'Custom Script';
  const name = opts.name || state.cs.name || 'custom_script';
  const runtimeConfigJson = JSON.parse(JSON.stringify(configJson || { config: {} }));
  runtimeConfigJson.config = runtimeConfigJson.config || {};
  const cfg = state.config || {};
  const first = (...values) => values.find((value) => value !== undefined && value !== null && String(value).trim() !== '');
  const setIfMissing = (key, value) => {
    if (runtimeConfigJson.config[key] === undefined || runtimeConfigJson.config[key] === null || String(runtimeConfigJson.config[key]).trim() === '') {
      const next = first(value);
      if (next !== undefined) runtimeConfigJson.config[key] = next;
    }
  };
  const env = first(opts.env, cfg.env, cfg.environment, runtimeDataJson?.targetEnv, state.cs?.targetEnv);
  if (runtimeConfigJson.config.publicApiBaseUrl) {
    runtimeConfigJson.config.publicApiBaseUrl = csResolveRuntimePublicApiBaseUrl(runtimeConfigJson.config.publicApiBaseUrl, env, { allowLocal: true });
  }
  if (runtimeConfigJson.config.apiBaseUrl) {
    runtimeConfigJson.config.apiBaseUrl = csResolveRuntimePublicApiBaseUrl(runtimeConfigJson.config.apiBaseUrl, env, { allowLocal: true });
  }
  setIfMissing('publicApiBaseUrl', csResolveRuntimePublicApiBaseUrl(first(cfg.publicApiBaseUrl, cfg.apiBaseUrl, cfg.bostonApi), env, { allowLocal: true }));
  setIfMissing('apiBaseUrl', csResolveRuntimePublicApiBaseUrl(cfg.apiBaseUrl, env, { allowLocal: true }));
  setIfMissing('apiKey', first(cfg.apiKey, cfg.publicApiKey, cfg.bostonAkey));
  setIfMissing('env', env);
  setIfMissing('pcc', first(cfg.pcc, cfg.PCC));
  setIfMissing('parentPcc', first(cfg.parentPcc, cfg.parent_pcc, cfg.ppcc));
  setIfMissing('user', first(cfg.user, cfg.email));
  setIfMissing('username', first(cfg.username, cfg.userName));
  setIfMissing('type_assign', first(cfg.type_assign, cfg.typeAssign));
  setIfMissing('advancedMode', opts.advancedMode === true ? 1 : 0);
  if (cfg.enableRuntimeApiTest === true || opts.realPreview === true) runtimeConfigJson.config.enableRuntimeApi = true;
  const uuid = opts.uuid || runtimeConfigJson?.config?.uuid || state.cs.uuid || 'no-uuid';
  const previewMode = !!opts.previewMode;
  const simulateApi = opts.simulateApi !== undefined ? !!opts.simulateApi : previewMode;
  const holdOnCompletion = opts.holdOnCompletion === true;

  // 1. Empezamos con el template y reemplazamos placeholders básicos
  let html = tpl.html
    .replace(/<title>[^<]*<\/title>/i, `<title>${title.replace(/</g,'&lt;')}<\/title>`)
    .replace(/id="headerTitle">[^<]*</, `id="headerTitle">${title.replace(/</g,'&lt;')}<`)
    .replace(/id="scriptNameBadge">[^<]*</, `id="scriptNameBadge">${name}<`)
    .replace(/id="uuidBadge">[^<]*</, `id="uuidBadge">${uuid}<`);

  // 2. Reemplazar <link rel="stylesheet" href="styles.css"> por <style> inline
  html = html.replace(
    /<link\s+rel=["']stylesheet["']\s+href=["']styles\.css["'][^>]*>/i,
    `<style>\n${tpl.css}\n</style>`
  );

  // 3. Bootstrap del shim ANTES de api.js: intercepta fetch para servir los JSON embebidos
  const dataLiteral = JSON.stringify(runtimeDataJson || {});
  const configLiteral = JSON.stringify(runtimeConfigJson || { config: { uuid, useInternalConfig: true } });
  const logicLiteral = JSON.stringify(opts.logicJson || state.cs.logicJson || { postCommands: state.cs.postCommands || [] });
  const catalogsLiteral = JSON.stringify(runtimeCatalogsJson || { version: 1, catalogs: {} });

  // Token de sesión: lo que esté guardado en Boston (state) o lo que el caller pase explícito
  const tokenForPreview = opts.token || (state.sessionToken || '');
  const envForPreview = opts.env || (runtimeDataJson?.targetEnv || state.cs?.targetEnv || 'stg');

  // Escapar cierre de tag script en los literales (defensivo: evita que se rompa el parser HTML)
  // Helper: escapa chars que rompen el parser cuando se embebe JSON dentro de un tag de script.
  // Cubre cierre de script, comentarios HTML y separadores de linea Unicode.
  function _safeForScript(s) {
    return String(s)
      .replace(/<\/script/gi, '<\\/script')
      .replace(/<!--/g, '<\\!--')
      .replace(/-->/g, '--\\>')
      .replace(/\u2028/g, '\\u2028')
      .replace(/\u2029/g, '\\u2029');
  }
  const safeData = _safeForScript(dataLiteral);
  const safeConfig = _safeForScript(configLiteral);
  const safeLogic = _safeForScript(logicLiteral);
  const safeCatalogs = _safeForScript(catalogsLiteral);
  const safeToken = JSON.stringify(tokenForPreview || null).replace(/<\/script/gi, '<\\/script');
  const safeEnv = JSON.stringify(envForPreview).replace(/<\/script/gi, '<\\/script');

  const shim = `<script>
(function(){
  // Datos embebidos por el single-file builder de Boston IA
  window.__BOSTON_EMBEDDED__ = true;
  window.__BOSTON_DATA__ = ${safeData};
  window.__BOSTON_CONFIG__ = ${safeConfig};
  window.__BOSTON_LOGIC__ = ${safeLogic};
  window.__BOSTON_CATALOGS__ = ${safeCatalogs};
  window.__BOSTON_PREVIEW_MODE__ = ${previewMode ? 'true' : 'false'};
  window.__BOSTON_SIMULATE_API__ = ${simulateApi ? 'true' : 'false'};
  window.__BOSTON_HOLD_ON_COMPLETE__ = ${holdOnCompletion ? 'true' : 'false'};
  window.__BOSTON_RUNTIME_CONTEXT__ = {
    token: ${safeToken},
    env: ${safeEnv}
  };
  // ----- nombres que el runtime app.js / api.js esperan -----
  window.__PREVIEW_DATA__ = window.__BOSTON_DATA__;
  window.__PREVIEW_CONFIG__ = window.__BOSTON_CONFIG__;
  window.__PREVIEW_LOGIC__ = window.__BOSTON_LOGIC__;
  window.__PREVIEW_CATALOGS__ = window.__BOSTON_CATALOGS__;
  window.__PREVIEW_TOKEN__ = ${safeToken};
  window.__PREVIEW_ENV__ = ${safeEnv};
  // Interceptor: si el runtime pide data.json o config_app.json, devolver lo embebido
  const __orig_fetch__ = window.fetch.bind(window);
  window.fetch = function(input, init){
    try {
      const u = (typeof input === 'string') ? input : (input && input.url) || '';
      if (/(^|\\/)data\\.json(\\?|$)/.test(u)) {
        return Promise.resolve(new Response(JSON.stringify(window.__BOSTON_DATA__), { status:200, headers:{'Content-Type':'application/json'} }));
      }
      if (/(^|\\/)config_app\\.json(\\?|$)/.test(u)) {
        return Promise.resolve(new Response(JSON.stringify(window.__BOSTON_CONFIG__), { status:200, headers:{'Content-Type':'application/json'} }));
      }
      if (/(^|\\/)logic\\.json(\\?|$)/.test(u)) {
        return Promise.resolve(new Response(JSON.stringify(window.__BOSTON_LOGIC__ || {}), { status:200, headers:{'Content-Type':'application/json'} }));
      }
      if (/(^|\\/)catalogs\\.json(\\?|$)/.test(u)) {
        return Promise.resolve(new Response(JSON.stringify(window.__BOSTON_CATALOGS__ || { version:1, catalogs:{} }), { status:200, headers:{'Content-Type':'application/json'} }));
      }
      if (window.__BOSTON_SIMULATE_API__) {
        // En preview mode, interceptar llamadas a Sabre para no impactar reservas reales
        if (/sabre|customScripts|catalogues|agency|webservices\\.sabre/i.test(u)) {
          return Promise.resolve(new Response(JSON.stringify({ preview:true, simulated:true, url:u, message:'[PREVIEW] Llamada simulada — no se envió nada a Sabre.' }), { status:200, headers:{'Content-Type':'application/json'} }));
        }
      }
    } catch(e) { /* fallback al fetch original */ }
    return __orig_fetch__(input, init);
  };
})();
<\/script>`;

  // 4. Reemplazar <script src="api.js"> y <script src="app.js"> por inline + shim
  // Encontramos la primera referencia a api.js y la sustituimos por el bloque completo
  const inlineApiApp = `${shim}\n<script>\n${tpl.api}\n<\/script>\n<script>\n${tpl.sst}\n${tpl.app}\n<\/script>`;

  // ⚠ BUG HISTÓRICO: String.replace(rx, str) interpreta `$'` como "todo lo que sigue
  // al match", corrompiendo el output cuando tpl.app contiene `$'` en sus regex.
  // SOLUCIÓN BULLETPROOF: usar split/join — no tiene ninguna interpretación especial de $.
  console.log('[csBuildSingleFile] BUILD: 219760-split-join @', new Date().toISOString());
  const combinedRx = /<script\s+src=["']api\.js["'][^>]*><\/script>\s*<script\s+src=["']app\.js["'][^>]*><\/script>/i;
  if (combinedRx.test(html)) {
    const parts = html.split(combinedRx);
    html = parts[0] + inlineApiApp + parts.slice(1).join('');
  } else {
    // Fallback: separados
    const apiRx = /<script\s+src=["']api\.js["'][^>]*><\/script>/i;
    const appRx = /<script\s+src=["']app\.js["'][^>]*><\/script>/i;
    if (apiRx.test(html)) {
      const p = html.split(apiRx);
      html = p[0] + `${shim}\n<script>\n${tpl.api}\n<\/script>` + p.slice(1).join('');
    }
    if (appRx.test(html)) {
      const p = html.split(appRx);
      html = p[0] + `<script>\n${tpl.sst}\n${tpl.app}\n<\/script>` + p.slice(1).join('');
    }
  }

  // 5. Banner si es preview
  if (previewMode) {
    html = html.replace(
      /<body([^>]*)>/i,
      `<body$1>\n<div style="position:fixed;top:0;left:0;right:0;z-index:9999;background:#f59e0b;color:#fff;text-align:center;font:600 12px/24px system-ui;padding:0 12px">⚠ MODO PREVIEW — las llamadas a Sabre están simuladas</div>\n<div style="height:24px"></div>`
    );
  }

  return html;
}

function generateFakeBookingData() {
  const months = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  const today = new Date();
  // Fecha base = hoy + 3 meses (check-in y check-out hotel/auto)
  const future = new Date(today.getFullYear(), today.getMonth() + 3, today.getDate());
  const checkout = new Date(future.getFullYear(), future.getMonth(), future.getDate() + 3);
  const fmt = d => String(d.getDate()).padStart(2,'0') + months[d.getMonth()];
  const dateStr = fmt(future);
  const checkoutStr = fmt(checkout);
  const airports = [
    { c:'EZE', city:'Buenos Aires' }, { c:'AEP', city:'Aeroparque' },
    { c:'MIA', city:'Miami' }, { c:'JFK', city:'New York' },
    { c:'LAX', city:'Los Angeles' }, { c:'MAD', city:'Madrid' },
    { c:'GRU', city:'Sao Paulo' }, { c:'SCL', city:'Santiago' },
    { c:'LIM', city:'Lima' }, { c:'BOG', city:'Bogota' },
    { c:'MEX', city:'Ciudad de Mexico' }, { c:'CUN', city:'Cancun' },
    { c:'MVD', city:'Montevideo' },
  ];
  const i = Math.floor(Math.random() * airports.length);
  let j = Math.floor(Math.random() * airports.length);
  while (j === i) j = Math.floor(Math.random() * airports.length);
  const apellidos = ['PEREZ','GARCIA','RODRIGUEZ','LOPEZ','MARTINEZ','SANCHEZ','GONZALEZ','FERNANDEZ','TORRES','RAMIREZ','SILVA','SANTOS'];
  const nombres = ['JUAN','MARIA','CARLOS','ANA','PEDRO','LUCIA','DIEGO','SOFIA','MARTIN','LAURA','PABLO','VALENTINA'];
  const titulos = ['MR','MRS','MS'];
  const lname = apellidos[Math.floor(Math.random() * apellidos.length)];
  const fname = nombres[Math.floor(Math.random() * nombres.length)];
  const titulo = titulos[Math.floor(Math.random() * titulos.length)];
  const hours = ['8A','9A','10A','11A','1P','2P','3P','4P','5P','6P'];
  const time = hours[Math.floor(Math.random() * hours.length)];
  const phone = '11-' + (4000 + Math.floor(Math.random()*5999)) + '-' + (1000 + Math.floor(Math.random()*8999));
  // Hotel: cadenas comunes (3 chars) y codigos de propiedad ficticios
  const hotelChains = [
    { c:'HI',  name:'Holiday Inn' },
    { c:'MC',  name:'Marriott' },
    { c:'SI',  name:'Sheraton' },
    { c:'HY',  name:'Hyatt' },
    { c:'BW',  name:'Best Western' },
  ];
  const hc = hotelChains[Math.floor(Math.random() * hotelChains.length)];
  // Auto: vendor 2 chars (ZI=Avis, ZD=Budget, ZE=Hertz, ZL=National)
  const carVendors = [
    { c:'ZI', name:'Avis' },{ c:'ZD', name:'Budget' },
    { c:'ZE', name:'Hertz' },{ c:'ZL', name:'National' },
  ];
  const cv = carVendors[Math.floor(Math.random() * carVendors.length)];
  const carCategories = ['ECAR','CCAR','ICAR','SCAR','FCAR'];
  // DOCS / APIS fake: pasaporte ARG, DOB ~30 anos atras, expiry ~5 anos al futuro
  const pad = n => String(n).padStart(2,'0');
  const dobYear = (today.getFullYear() - 30 - Math.floor(Math.random()*15)) % 100;
  const dobMonth = Math.floor(Math.random()*12);
  const dobDay = 1 + Math.floor(Math.random()*27);
  const docsDob = pad(dobDay) + months[dobMonth] + pad(dobYear);
  const expYear = (today.getFullYear() + 5) % 100;
  const expMonth = (today.getMonth() + Math.floor(Math.random()*6)) % 12;
  const expDay = 1 + Math.floor(Math.random()*27);
  const docsExp = pad(expDay) + months[expMonth] + pad(expYear);
  // Passport ARG: 2 letras + 6 digitos (formato real)
  const letters = 'ABCDEFGHJKLMNPRSTUVXYZ';
  const docsPassport = letters[Math.floor(Math.random()*letters.length)] + letters[Math.floor(Math.random()*letters.length)] +
    String(100000 + Math.floor(Math.random()*899999));
  const docsSex = (titulo === 'MR') ? 'M' : 'F';
  // Datos de contacto/documentos ficticios (alimentan la precarga de los forms)
  const dni = String(20000000 + Math.floor(Math.random() * 25000000));
  const cuil = ((titulo === 'MR') ? '20' : '27') + '-' + dni + '-' + Math.floor(Math.random() * 10);
  const celular = '11' + String(40000000 + Math.floor(Math.random() * 59999999)); // 1165244572: sin 0 ni 15
  const email = (fname + '.' + lname + Math.floor(Math.random() * 99) + '@TESTMAIL.COM').toUpperCase();
  const addr = 'AV CORRIENTES ' + (100 + Math.floor(Math.random() * 4900)) + ' BUENOS AIRES AR';

  return {
    // VUELO
    date: dateStr, origin: airports[i].c, originName: airports[i].city,
    dest: airports[j].c, destName: airports[j].city,
    time, cls: 'Y', seats: '1',
    // PAX
    lname, fname, titulo, phone, email, dni, cuil, celular, addr,
    // DOCS / APIS
    docsCountry: 'ARG', docsPassport, docsDob, docsExp, docsSex,
    // HOTEL (en el destino del vuelo, check-in mismo dia que vuelo, 3 noches)
    hotelChain: hc.c, hotelChainName: hc.name,
    hotelCity: airports[j].c, hotelCheckin: dateStr, hotelCheckout: checkoutStr,
    // AUTO (en destino, mismo periodo, vendor + categoria)
    carVendor: cv.c, carVendorName: cv.name,
    carCity: airports[j].c, carPickup: dateStr, carReturn: checkoutStr,
    carPickupTime: '1000', carReturnTime: '1000',
    carCategory: carCategories[Math.floor(Math.random()*carCategories.length)],
  };
}



function csReindexTags() {
  // FIX preservacion: NO pisar tags existentes — el runtime y los remark_mask referencian
  // los tags semanticos del agente ("inits", "line1", "DATE"...). Solo se asigna tag
  // field_N a campos nuevos creados a mano en el builder.
  const used = new Set();
  for (const form of state.cs.forms || [])
    for (const field of form.remarks || [])
      if (field.tag) used.add(field.tag);
  let n = 0;
  for (const form of state.cs.forms || []) {
    for (const field of form.remarks || []) {
      if (!field.tag) {
        while (used.has('field_' + n)) n++;
        field.tag = 'field_' + n;
        used.add(field.tag);
      }
    }
  }
}


export { csReindexTags, csLoadRuntimeTemplates, csFetchTemplate, csBuildDataJson, csBuildConfigJson, csBuildIndexHtmlFromTemplate, buildScriptBundle, generateScriptFiles, previewScriptBundle, downloadScriptFile, downloadScriptBundle, csSaveToServer, csPersistAndPublish, csProposeToKB, csBuildZip, csBuildSingleFile, csBuildPublishPayload, generateFakeBookingData}
